{
  "seo": {
    "title": "TALENXA | Organizational consulting",
    "description": "TALENXA helps growing companies turn strategy into execution through organization, leadership and performance."
  },
  "nav": {
    "services": "Solutions",
    "approach": "How we work",
    "whoWeServe": "Who we serve",
    "contact": "Contact",
    "cta": "Book a conversation"
  },
  "hero": {
    "kicker": "Organizational consulting · Dominican Republic",
    "title": "We turn strategy into execution through talent.",
    "body": "We help growing companies build the leaders, performance systems and organizational capabilities that turn strategic priorities into results.",
    "primary": "Book an executive conversation",
    "secondary": "See how we work",
    "context": "For companies that are growing, professionalizing or transforming.",
    "visualLabel": "The TALENXA execution framework",
    "visualEyebrow": "THE TALENXA SYSTEM",
    "visualResult": "BETTER EXECUTION"
  },
  "executionPath": [
    "Strategy",
    "Organization",
    "Leadership",
    "Performance"
  ],
  "media": {
    "heroAlt": "Executive team reviewing priorities and metrics in a strategy meeting.",
    "whoAlt": "Leaders discussing business decisions around a working table."
  },
  "problem": {
    "kicker": "The execution gap",
    "title": "Growth changes the rules of the game.",
    "intro": "As a company enters a new stage, the practices that once worked may no longer support execution.",
    "items": [
      "The organization grows, but leadership does not always evolve at the same pace.",
      "Objectives exist, but do not always translate into accountability.",
      "HR operates, but is not always connected to strategic priorities.",
      "Isolated initiatives consume energy without building sustainable change."
    ]
  },
  "thinking": {
    "kicker": "How we think",
    "title": "We do not begin by asking what course your company needs.",
    "body": "We begin by understanding what needs to change for your strategy to be executed more effectively. Then we design the organizational capability needed to make it real.",
    "pathLabel": "Strategy, organization, leadership, performance and execution",
    "path": [
      "Strategy",
      "Organization",
      "Leadership",
      "Performance",
      "Execution"
    ]
  },
  "solutions": {
    "kicker": "TALENXA solutions",
    "title": "We intervene where execution is losing strength.",
    "intro": "A progressive architecture: we enter with clarity, design the needed model and enable those responsible for running it.",
    "diagnosticCta": "Explore the diagnostic",
    "items": [
      {
        "label": "Entry point",
        "title": "Organizational & HR Diagnostic",
        "body": "We identify the organizational and talent-management gaps affecting execution and create a prioritized roadmap.",
        "points": [
          "Gap map",
          "Quick wins",
          "90–180 day roadmap"
        ]
      },
      {
        "label": "Core solution",
        "title": "Performance & Leadership",
        "body": "We design performance and leadership systems aligned with business priorities, and enable the leaders responsible for executing them.",
        "points": [
          "Objectives and KPIs",
          "Review cadence",
          "Performance conversations"
        ]
      },
      {
        "label": "Premium solution",
        "title": "Organizational Transformation",
        "body": "We redesign structures, roles, capabilities and ways of working when the business enters a new stage.",
        "points": [
          "Organization design",
          "Roles and responsibilities",
          "Transformation roadmap"
        ]
      },
      {
        "label": "Specialist capabilities",
        "title": "Compliance & Rewards",
        "body": "We strengthen compensation, rewards and compliance practices as complementary organizational capabilities.",
        "points": [
          "Salary structures",
          "Internal equity",
          "Employment practices"
        ]
      }
    ]
  },
  "approach": {
    "kicker": "How we work",
    "title": "Diagnose. Design. Enable. Reinforce.",
    "intro": "Structured enough to be rigorous. Practical enough to be implemented within your organization.",
    "principle": "TALENXA provides the blueprint; your leaders drive and sustain execution.",
    "steps": [
      {
        "title": "Diagnose",
        "body": "We identify the gaps limiting execution."
      },
      {
        "title": "Design",
        "body": "We build the right model for your context."
      },
      {
        "title": "Enable",
        "body": "We prepare the leaders who must run it."
      },
      {
        "title": "Reinforce",
        "body": "We support adoption, learning and adjustment."
      }
    ]
  },
  "outcomes": {
    "kicker": "What can change",
    "title": "Capabilities that make strategy more executable.",
    "intro": "We do not promise arbitrary financial outcomes. We work on the systems and behaviors an organization can control.",
    "items": [
      {
        "title": "Leadership",
        "points": [
          "Clearer responsibilities",
          "Better performance conversations",
          "Greater delegation capacity"
        ]
      },
      {
        "title": "Performance",
        "points": [
          "Aligned objectives",
          "Clear KPIs",
          "Better deviation management"
        ]
      },
      {
        "title": "Organization",
        "points": [
          "Clearer roles",
          "Less duplication",
          "Fit-for-purpose organizational capacity"
        ]
      },
      {
        "title": "Talent / HR",
        "points": [
          "Business-connected agenda",
          "Critical capabilities identified",
          "Better management systems"
        ]
      }
    ]
  },
  "who": {
    "kicker": "Who we serve",
    "title": "Built for organizations entering their next stage.",
    "body": "",
    "situations": [
      "Accelerated growth",
      "Management professionalization",
      "Expansion or new business units",
      "Restructuring",
      "Organizational transformation",
      "Need for stronger accountability"
    ]
  },
  "distinction": {
    "kicker": "What we are not",
    "title": "The problem is not solved by an isolated intervention.",
    "items": [
      "We do not sell stand-alone courses.",
      "We do not provide HR outsourcing.",
      "We do not deliver diagnostics that end in a PDF."
    ],
    "conclusion": "We design organizational capabilities for better strategy execution."
  },
  "cta": {
    "kicker": "Executive conversation",
    "title": "What is making your strategy harder to execute today?",
    "body": "Let’s discuss your priorities, the gaps that may be affecting them, and whether a diagnostic can bring clarity.",
    "button": "Book an executive conversation"
  },
  "contact": {
    "kicker": "Let’s talk",
    "title": "Start a conversation about your organization.",
    "body": "Briefly share your context. The first conversation is designed to understand your priority, not sell you a generic solution.",
    "note": "Santo Domingo, Dominican Republic"
  },
  "form": {
    "name": "Name",
    "company": "Company",
    "companySize": "Company size",
    "role": "Role",
    "email": "Business email",
    "challenge": "Which challenge is affecting execution?",
    "message": "Additional message (optional)",
    "send": "Send request",
    "subtitle": "Tell us the essentials. We will get in touch to arrange an executive conversation.",
    "roleOptions": [
      {
        "value": "CEO / General Management",
        "label": "CEO / General Management"
      },
      {
        "value": "Owner / Shareholder",
        "label": "Owner / Shareholder"
      },
      {
        "value": "HR Leadership",
        "label": "HR Leadership"
      },
      {
        "value": "Operations Leadership",
        "label": "Operations Leadership"
      },
      {
        "value": "Other leader",
        "label": "Other leader"
      }
    ],
    "challengeOptions": [
      {
        "value": "Leadership and accountability",
        "label": "Leadership and accountability"
      },
      {
        "value": "Performance and KPIs",
        "label": "Performance and KPIs"
      },
      {
        "value": "Structure or organization",
        "label": "Structure or organization"
      },
      {
        "value": "Transformation",
        "label": "Transformation"
      },
      {
        "value": "HR connected to the business",
        "label": "HR connected to the business"
      },
      {
        "value": "Other",
        "label": "Other"
      }
    ],
    "companySizeOptions": [
      {
        "value": "1-10",
        "label": "1-10"
      },
      {
        "value": "11-50",
        "label": "11-50"
      },
      {
        "value": "51-200",
        "label": "51-200"
      },
      {
        "value": "201-500",
        "label": "201-500"
      },
      {
        "value": "500+",
        "label": "500+"
      }
    ],
    "nameRequired": "Please enter your name",
    "companyRequired": "Please enter your company",
    "companySizeRequired": "Please select the company size",
    "roleRequired": "Please select your role",
    "emailRequired": "Please enter your business email",
    "emailValid": "Enter a valid email",
    "challengeRequired": "Please select the main challenge",
    "success": "Request received.",
    "successSubtitle": "We will review the context you shared and contact you confidentially.",
    "reset": "Send another request",
    "privacy": "We guarantee complete confidentiality and discretion in handling your information."
  },
  "footer": {
    "tagline": "Organizational consulting to turn strategy into execution.",
    "rights": "All rights reserved."
  }
}